<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
		
		<!-- 品牌商品在类目中所占的比例 --> 
    	<div class="brand-cate-half" style="height:500px" ref="catebrandtop" v-loading="catetobrandpercentloading">
			<span class="brand-cate-half-percent">品牌所属类目占比（此处只统计一级分类）</span>
			<el-button type="primary" icon="el-icon-refresh" size="small" style="float:left;margin-left:1%" @click="getcatetobrandpercent">刷新</el-button>
			<div class="brand-cate-half-main" style="height:500px">
				<IEcharts :option="catebrands"/>
			</div>
		</div>

		<!-- 分类销售额占比 -->
		<div class="brand-cate-half" style="height:500px" v-loading="catesalesloading">
			<span class="brand-cate-half-percent">类目销售占比</span>
			<div class="brand-cate-half-title">
				<el-select v-model="catesalepercentquery.channelids" multiple filterable placeholder="请选择销售渠道" style="width:100%" size="small" @change="getcatesalespercent">
		            <el-option v-for="(item,index) in channellists" :key="index" :label="item.name" :value="item.id"></el-option>
		        </el-select> 
				<el-button :type="catesalepercentquery.month==item.name ? 'success' : ''" size="small" v-for="(item,index) in months" :key="index" style="margin:10px 10px 0 0" @click="getmonths(item.name)">{{item.name}}</el-button>
				<el-button type="primary" icon="el-icon-search" size="small" @click="checkcatesalesfromtable">查看列表数据</el-button>
			</div>
			<div class="brand-cate-half-stat">
				<div style="float:right;width:100%;height:400px">
					<IEcharts :option="catesalepercent"/>
				</div>
			</div>
		</div>
		<el-dialog title="店铺标签设置" :visible.sync="catesaletableDialog" width="50%" top="10vh">
			<div style="float:left;width:100%;padding:10px;font-size:13px;color:#E6A23C">
				<span style="float:left;margin-right:5%">本月累计实收：<i style="font-size:14px;font-style:normal;font-weight:bold">￥{{catesaleslists.allreals}}</i></span>
				<span style="float:left;margin-right:5%">上月累计实收：<i style="font-size:14px;font-style:normal;font-weight:bold">￥{{catesaleslists.allyesterdayreals}}</i></span>
				<span style="float:left;margin-right:5%">本月环比增长率：<i style="font-size:14px;font-style:normal;font-weight:bold">{{catesaleslists.allcompare > 0 ? catesaleslists.allcompare+'% ↑' : catesaleslists.allcompare+'% ↓' }}</i></span>
			</div>
			<div class="shop-sale-table" style="margin-top:10px">
			<table>
				<tr>
					<td class="shoptitle" align="left">类目</td>
					<td class="shoptitle" align="center">本月实收金额</td>
					<td class="shoptitle" align="center">上月实收金额</td>
					<td class="shoptitle" align="center">本月占比（%）</td>
					<td class="shoptitle" align="center">环比增长率（%）</td>	
				</tr>
				<tr v-for="(item,index) in catesaleslists.lists" :key="index">
					<td align="left">{{item.name}}</td>
					<td align="center">￥{{item.reals}}</td>
					<td align="center">￥{{item.yestodayreals}}</td>
					<td align="center">{{item.salepercent}}%</td>
					<td align="center">{{item.comparepercent > 0 ? item.comparepercent+'% ↑' : item.comparepercent+'% ↓' }}</td>	
				</tr>
			</table>
			</div>
		</el-dialog>



		<!-- 品类、品牌零售额 -->
		<div class="brand-cate-all">
			<span class="brand-cate-half-percent">品类、品牌销售趋势图</span>
			<div :class="isbottom ? 'brand-cate-half-title brand-cate-move' : 'brand-cate-half-title' " ref="brandtitle">
				<el-select v-model="saleallquery.channelids" multiple filterable placeholder="请选择销售渠道" style="width:35%" size="small" @change="changesaleschannel">
		            <el-option v-for="(item,index) in channellists" :key="index" :label="item.name" :value="item.id"></el-option>
		        </el-select>
				<el-select v-model="saleallquery.cateid" clearable filterable placeholder="请选择分类" size="small" @change="changesalescate">
		            <el-option v-for="(item,index) in catelists" :key="index" :label="item.name" :value="item.id"></el-option>
		        </el-select>  
				<el-select v-model="saleallquery.brandid" clearable filterable placeholder="请选择品牌" size="small" @change="changesalebrand">
		            <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
              	  	  <span style="float: left">{{item.name}}</span>
      				  <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
              	  	</el-option>
		        </el-select>  
				<el-select v-model="saleallquery.productid" size="small" clearable filterable remote reserve-keyword :remote-method="getProduct" :loading="productloading" placeholder="商品名称 / 编号 / 基本条码" @change="changeproduct" style="width:25%">
		          	<el-option v-for="(item,index) in productlists" :key="index" :label="item.name" :value="item.id"></el-option>
		        </el-select>
			</div>
			<div class="brand-cate-half-stat">
				<!-- 实收金额趋势图 -->
				<div style="float:right;width:100%;height:300px;margin-top:30px" v-loading="saleallquery.loading1">
					<IEcharts :option="realsales" :loading="custnaoLoading"/>
				</div>
				<!-- 商品销量图 -->
				<div style="float:right;width:100%;height:300px;margin-top:30px" v-loading="saleallquery.loading2" v-if="saleallquery.productid > 0">
					<IEcharts :option="goodssales" :loading="custnaoLoading"/>
				</div>
				<!-- 利润趋势图 -->
				<div style="float:right;width:100%;height:300px;margin-top:30px" v-loading="saleallquery.loading3">
					<IEcharts :option="profitssales" :loading="custnaoLoading"/>
				</div>
				<!-- 毛利率趋势图 -->
				<div style="float:right;width:100%;height:300px;margin-top:30px" v-loading="saleallquery.loading4">
					<IEcharts :option="profitsclearsales" :loading="custnaoLoading"/>
				</div>
				<!-- 订单量趋势图 -->
				<div style="float:right;width:100%;height:300px;margin-top:30px" v-loading="saleallquery.loading5">
					<IEcharts :option="orderssales" :loading="custnaoLoading"/>
				</div>
				<!-- 客单价趋势图 -->
				<div style="float:right;width:100%;height:300px;margin-top:30px;margin-bottom:30px" v-loading="saleallquery.loading6">
					<IEcharts :option="averagesales" :loading="custnaoLoading"/>
				</div>
			</div>
		</div>

    	    	
    </div>
    </transition>
</template>

<script>

import IEcharts from 'vue-echarts-v3/src/full.js';
export default {
	components: {IEcharts},
    data () {
	    return {
	        url:this.GLOBAL.domain+"Datastat/index",
	        transitionshow:true,
	        actionauth:[],
			channelids:[],
			channellists:[
				{id:0,name:'线下订单'},
				{id:1,name:'商城订单'},
				{id:3,name:'小程序订单'},
				{id:4,name:'联营分销'},
				{id:6,name:'邀请有理'},
			],

			catetobrandpercentloading:false,
			catebrands: {
				color:['#ee6666','#73c0de','#5470c6','#91cc75','#fac858','#409EFF','#67C23A'],
				series: [
					{
						name: '访问来源',
						type: 'pie',
						radius: '50%',
						data: [],
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}
				]
			},

			months:[],
			catesalesloading:false,
			catesalepercentquery: {
				act:'getcatesalepercent',
				token:this.$cookies.get('token'),
				channelids:[],
				month:'',
			},
			catesaleslists:'',
			catesaletableDialog:false,
			catesalepercent: {
				color:['#ee6666','#73c0de','#5470c6','#91cc75','#fac858','#409EFF','#67C23A'],
				series: [
					{
						name: '访问来源',
						type: 'pie',
						radius: '50%',
						data: [],
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}
				]
			},

			saleallquery: {
				act:'getrealsaleorders',
				token:this.$cookies.get('token'),
				channelids:[],
				cateid:'',
				brandid:'',
				productid:'',
				loading1:false,
				loading2:false,
				loading3:false,
				loading4:false,
				loading5:false,
				loading6:false,
			},
			catelists:[],
			brandlists:[],
			brandquery: {
				act:'lists',
				token:this.$cookies.get('token'),
				cateid:'',
				rollpage:100000
			},
			productquery: {
				act:'lists',
				token:this.$cookies.get('token'),
				brandid:'',
				key:'',
				rollpage:100000
			},
			productloading:false,
			productlists:[],
			realsales: {
				title: {
					text: '实收金额趋势图',
					left: 'center',
					textStyle: {
						color:'#333333',
						fontSize:14,
						fontWeight:'normal',
					},
					
				},
				legend: {
					data:['销售额','环比增长率'],
					show:false
				},
				xAxis: {			  
					type: 'category', //时间段
					data: [], // x轴数据
					name: '', //x轴名称
					boundaryGap: true,
					nameTextStyle: { //x轴名称样式
						fontWeight: 600,
						fontSize: 18,
						width: 20,
					},
					axisTick: {
						alignWithLabel: true
					},  
				},
				yAxis: [
					{
						type: 'value',
						name: '销售额',
						splitLine: { //去除网格线
							show:false,
						},
						position:'left',
						nameTextStyle: { //y轴名称样式
							fontWeight: 400,
							fontSize: 13,
						},
					},
					{
						type: 'value',
						name: '环比增长率',
						splitLine: { //去除网格线
							show:false,
						},
						position:'right',
						nameTextStyle: { //y轴名称样式
							fontWeight: 400,
							fontSize: 13,
						},
						axisLabel: {
							formatter: '{value} %'
						}
					},
				],     
				tooltip: {
					trigger: 'axis', //axis item none三个值
					textStyle: {
						fontSize:13,
					},
					formatter: function (params) {
        				let firstParams = params[0];
        				let sndParams = params[1];
        				return firstParams.name + '<br/>' + "销售额：" + firstParams.value + "<br/>" + "环比增长率："+ sndParams.value+"%";
    				}
				},
				
				series: [
					{
						name: ['销售额'],
						data: [],
						type: 'bar',
						barWidth : 40,
						barGap: 0,
						itemStyle : {
							normal : {
								color:'#5470c6',
							}
						},
						label: {
							normal: {
								show: true,
								position:'top',
								align:'center',
								formatter: function(v) {
									return '{a|'+v.value+'}';
								},
								rich: {
									a: {
										color:'#333333',
										fontSize:12,
										lineHeight:18,
									}
								},
							}
						},
					},
					{
						name: ['环比增长率'],
						yAxisIndex: 1,
						data: [],
						type: 'line',
						barWidth : 40,
						barGap: 0,
						itemStyle : {
							normal : {
								color:'#73c0de',
							}
						}
					},
				]
			},

			goodssales: {
				title: {
					text: '商品销量趋势图',
					left: 'center',
					textStyle: {
						color:'#333333',
						fontSize:14,
						fontWeight:'normal',
					},
					
				},
				legend: {
					data:['销售额','环比增长率'],
					show:false
				},
				xAxis: {			  
					type: 'category', //时间段
					data: [], // x轴数据
					name: '', //x轴名称
					boundaryGap: true,
					nameTextStyle: { //x轴名称样式
						fontWeight: 600,
						fontSize: 18,
						width: 20,
					},
					axisTick: {
						alignWithLabel: true
					},  
				},
				yAxis: [
					{
						type: 'value',
						name: '销售额',
						splitLine: { //去除网格线
							show:false,
						},
						position:'left',
						nameTextStyle: { //y轴名称样式
							fontWeight: 400,
							fontSize: 13,
						},
					},
					{
						type: 'value',
						name: '环比增长率',
						splitLine: { //去除网格线
							show:false,
						},
						position:'right',
						nameTextStyle: { //y轴名称样式
							fontWeight: 400,
							fontSize: 13,
						},
						axisLabel: {
							formatter: '{value} %'
						}
					},
				],     
				tooltip: {
					trigger: 'axis',
					textStyle: {
						fontSize:13,
					},
					formatter: function (params) {
        				let firstParams = params[0];
        				let sndParams = params[1];
        				return firstParams.name + '<br/>' + "销售数量：" + firstParams.value + "<br/>" + "环比增长率："+ sndParams.value+"%";
    				}
				},
				
				series: [
					{
						name: ['销售额'],
						data: [],
						type: 'bar',
						barWidth : 40,
						barGap: 0,
						itemStyle : {
							normal : {
								color:'#fac858',
							}
						},
						label: {
							normal: {
								show: true,
								position:'top',
								align:'center',
								formatter: function(v) {
									return '{a|'+v.value+'}';
								},
								rich: {
									a: {
										color:'#333333',
										fontSize:12,
										lineHeight:18,
									}
								},
							}
						},
					},
					{
						name: ['环比增长率'],
						yAxisIndex: 1,
						data: [],
						type: 'line',
						barWidth : 40,
						barGap: 0,
						itemStyle : {
							normal : {
								color:'#73c0de',
							}
						},
					},
				]
			},

			profitssales: {
				title: {
					text: '利润趋势图',
					left: 'center',
					textStyle: {
						color:'#333333',
						fontSize:14,
						fontWeight:'normal',
					},
					
				},
				legend: {
					data:['利润','环比增长率'],
					show:false
				},
				xAxis: {			  
					type: 'category', //时间段
					data: [], // x轴数据
					name: '', //x轴名称
					boundaryGap: true,
					nameTextStyle: { //x轴名称样式
						fontWeight: 600,
						fontSize: 18,
						width: 20,
					},
					axisTick: {
						alignWithLabel: true
					},  
				},
				yAxis: [
					{
						type: 'value',
						name: '利润',
						splitLine: { //去除网格线
							show:false,
						},
						position:'left',
						nameTextStyle: { //y轴名称样式
							fontWeight: 400,
							fontSize: 13,
						},
					},
					{
						type: 'value',
						name: '环比增长率',
						splitLine: { //去除网格线
							show:false,
						},
						position:'right',
						nameTextStyle: { //y轴名称样式
							fontWeight: 400,
							fontSize: 13,
						},
						axisLabel: {
							formatter: '{value} %'
						}
					},
				],     
				tooltip: {
					trigger: 'axis',
					textStyle: {
						fontSize:13,
					},
					formatter: function (params) {
        				let firstParams = params[0];
        				let sndParams = params[1];
        				return firstParams.name + '<br/>' + "销售利润：" + firstParams.value + "<br/>" + "环比增长率："+ sndParams.value+"%";
    				}
				},
				series: [
					{
						name: ['利润'],
						data: [],
						type: 'bar',
						barWidth : 40,
						barGap: 0,
						itemStyle : {
							normal : {
								color:'#91cc75',
							}
						},
						label: {
							normal: {
								show: true,
								position:'top',
								align:'center',
								formatter: function(v) {
									return '{a|'+v.value+'}';
								},
								rich: {
									a: {
										color:'#333333',
										fontSize:12,
										lineHeight:18,
									}
								},
							}
						},
					},
					{
						name: ['环比增长率'],
						yAxisIndex: 1,
						data: [],
						type: 'line',
						barWidth : 40,
						barGap: 0,
						itemStyle : {
							normal : {
								color:'#ee6666',
							}
						},
					},
				]
			},

			profitsclearsales: {
				title: {
					text: '毛利率趋势图',
					left: 'center',
					textStyle: {
						color:'#333333',
						fontSize:14,
						fontWeight:'normal',
					},
					
				},
				legend: {
					data:['毛利率','环比增长率'],
					show:false
				},
				xAxis: {			  
					type: 'category', //时间段
					data: [], // x轴数据
					name: '', //x轴名称
					boundaryGap: true,
					nameTextStyle: { //x轴名称样式
						fontWeight: 600,
						fontSize: 18,
						width: 20,
					},
					axisTick: {
						alignWithLabel: true
					},  
				},
				yAxis: [
					{
						type: 'value',
						name: '毛利率',
						splitLine: { //去除网格线
							show:false,
						},
						position:'left',
						nameTextStyle: { //y轴名称样式
							fontWeight: 400,
							fontSize: 13,
						},
						axisLabel: {
							formatter: '{value} %'
						}
					},
					{
						type: 'value',
						name: '环比增长率',
						splitLine: { //去除网格线
							show:false,
						},
						position:'right',
						nameTextStyle: { //y轴名称样式
							fontWeight: 400,
							fontSize: 13,
						},
						axisLabel: {
							formatter: '{value} %'
						}
					},
				],     
				tooltip: {
					trigger: 'axis',
					textStyle: {
						fontSize:13,
					},
					formatter: function (params) {
        				let firstParams = params[0];
        				let sndParams = params[1];
        				return firstParams.name + '<br/>' + "利润率：" + firstParams.value + "%<br/>" + "环比增长率："+ sndParams.value+"%";
    				},
				},
				
				series: [
					{
						name: ['毛利率'],
						data: [],
						type: 'bar',
						barWidth : 40,
						barGap: 0,
						itemStyle : {
							normal : {
								color:'#409EFF',
							}
						},
						label: {
							normal: {
								show: true,
								position:'top',
								align:'center',
								formatter: function(v) {
									return '{a|'+v.value+'%}';
								},
								rich: {
									a: {
										color:'#333333',
										fontSize:12,
										lineHeight:18,
									}
								},
							}
						},
					},
					{
						name: ['环比增长率'],
						yAxisIndex: 1,
						data: [],
						type: 'line',
						barWidth : 40,
						barGap: 0,
						itemStyle : {
							normal : {
								color:'#ee6666',
							}
						},
					},
				]
			},


			orderssales: {
				title: {
					text: '订单量趋势图',
					left: 'center',
					textStyle: {
						color:'#333333',
						fontSize:14,
						fontWeight:'normal',
					},
					
				},
				legend: {
					data:['订单量','环比增长率'],
					show:false
				},
				xAxis: {			  
					type: 'category', //时间段
					data: [], // x轴数据
					name: '', //x轴名称
					boundaryGap: true,
					nameTextStyle: { //x轴名称样式
						fontWeight: 600,
						fontSize: 18,
						width: 20,
					},
					axisTick: {
						alignWithLabel: true
					},  
				},
				yAxis: [
					{
						type: 'value',
						name: '订单量',
						splitLine: { //去除网格线
							show:false,
						},
						position:'left',
						nameTextStyle: { //y轴名称样式
							fontWeight: 400,
							fontSize: 13,
						},
					},
					{
						type: 'value',
						name: '环比增长率',
						splitLine: { //去除网格线
							show:false,
						},
						position:'right',
						nameTextStyle: { //y轴名称样式
							fontWeight: 400,
							fontSize: 13,
						},
						axisLabel: {
							formatter: '{value} %'
						}
					},
				],     
				tooltip: {
					trigger: 'axis',
					textStyle: {
						fontSize:13,
					},
					formatter: function (params) {
        				let firstParams = params[0];
        				let sndParams = params[1];
        				return firstParams.name + '<br/>' + "订单量：" + firstParams.value + "<br/>" + "环比增长率："+ sndParams.value+"%";
    				},
				},
				
				series: [
					{
						name: ['订单量'],
						data: [],
						type: 'bar',
						barWidth : 40,
						barGap: 0,
						itemStyle : {
							normal : {
								color:'#8366ee',
							}
						},
						label: {
							normal: {
								show: true,
								position:'top',
								align:'center',
								formatter: function(v) {
									return '{a|'+v.value+'}';
								},
								rich: {
									a: {
										color:'#333333',
										fontSize:12,
										lineHeight:18,
									}
								},
							}
						},
					},
					{
						name: ['环比增长率'],
						yAxisIndex: 1,
						data: [],
						type: 'line',
						barWidth : 40,
						barGap: 0,
						itemStyle : {
							normal : {
								color:'#666666',
							}
						},
					},
				]
			},


			averagesales: {
				title: {
					text: '客单价趋势图',
					left: 'center',
					textStyle: {
						color:'#333333',
						fontSize:14,
						fontWeight:'normal',
					},
					
				},
				legend: {
					data:['客单价','环比增长率'],
					show:false
				},
				xAxis: {			  
					type: 'category', //时间段
					data: [], // x轴数据
					name: '', //x轴名称
					boundaryGap: true,
					nameTextStyle: { //x轴名称样式
						fontWeight: 600,
						fontSize: 18,
						width: 20,
					},
					axisTick: {
						alignWithLabel: true
					},  
				},
				yAxis: [
					{
						type: 'value',
						name: '客单价',
						splitLine: { //去除网格线
							show:false,
						},
						position:'left',
						nameTextStyle: { //y轴名称样式
							fontWeight: 400,
							fontSize: 13,
						},
					},
					{
						type: 'value',
						name: '环比增长率',
						splitLine: { //去除网格线
							show:false,
						},
						position:'right',
						nameTextStyle: { //y轴名称样式
							fontWeight: 400,
							fontSize: 13,
						},
						axisLabel: {
							formatter: '{value} %'
						}
					},
				],     
				tooltip: {
					trigger: 'axis',
					textStyle: {
						fontSize:13,
					},
					formatter: function (params) {
        				let firstParams = params[0];
        				let sndParams = params[1];
        				return firstParams.name + '<br/>' + "客单价：" + firstParams.value + "<br/>" + "环比增长率："+ sndParams.value+"%";
    				}
				},
				
				series: [
					{
						name: ['客单价'],
						data: [],
						type: 'bar',
						barWidth : 40,
						barGap: 0,
						itemStyle : {
							normal : {
								color:'#edb948',
							}
						},
						label: {
							normal: {
								show: true,
								position:'top',
								align:'center',
								formatter: function(v) {
									return '{a|'+v.value+'}';
								},
								rich: {
									a: {
										color:'#333333',
										fontSize:12,
										lineHeight:18,
									}
								},
							}
						},
					},
					{
						name: ['环比增长率'],
						yAxisIndex: 1,
						data: [],
						type: 'line',
						barWidth : 40,
						barGap: 0,
						itemStyle : {
							normal : {
								color:'#666666',
							}
						},
					},
				]
			},

			isbottom:false,
			
	    }
    },
    
    mounted(){
		/** 鼠标滚动判断导航是否置底 **/
		var _this=this;
		var starttop=this.$refs.catebrandtop.offsetTop;
		var navtop=this.$refs.brandtitle.offsetTop;
		window.addEventListener('scroll',function(e){
			e.target.scrollTop > (navtop-starttop) ? _this.isbottom=true : _this.isbottom=false;
		},true)
		
		this.getactionauth(); //获取权限设置
		this.getBrand(); //获取品牌信息
		this.getCategoryList(); //获取一级分类信息

		this.getcatetobrandpercent(); //获取商品个数所占分类的比例
		this.getlocalmonths(); //获取今年月份信息
		this.freshallstats(); //获取6图数据统计信息

    },
    
    methods:{   
     
	    /** 获取操作功能权限 **/
	  	getactionauth() {
	    	var data =this.$cookies.get('actionauth');
	    	data=JSON.parse(data);
	        this.actionauth=data;
	    },


		/** 获取品牌信息 **/
		getBrand(){
			var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
			resource.query(this.brandquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.brandlists = JSON.parse(Base64.decode(res.data.Data));
				}
			}).catch((res) => {
				this.$message.error(this.GLOBAL.errortext);
			});
		},

		/** 获取分类列表 **/
		getCategoryList(){
			var resource = this.$resource(this.GLOBAL.domain+"Product/index");
			resource.query({ act:'getcatelist',level:1,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.catelists = JSON.parse(Base64.decode(res.data.Data));
				}
			}).catch((res) => {
				
			});
		},

		/** 获取商品列表 **/
		getProduct(val) {
			this.productquery.brandid=this.saleallquery.brandid;
			this.productquery.key=val;
			
			this.productloading = true;
       		var resource = this.$resource(this.GLOBAL.domain+"Product/index");
        	resource.query(this.productquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.productloading = false;
				}else{
					this.productlists = JSON.parse(Base64.decode(res.data.Data));
					this.productloading = false;           		
				}
			}).catch((res) => {
				this.$message.error(this.GLOBAL.errortext);
				this.productloading=false;
			});

		},


		/** 获取品牌所属商品占类目比例（只统计一级类目） **/
		getcatetobrandpercent() {
			this.catetobrandpercentloading=true;
			var resource = this.$resource(this.url);
			resource.query({act:'getcatetobrandpercent',token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.catetobrandpercentloading=false;
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					this.catebrands.series[0].data=[];
					this.catebrands.series[0].data=result;
					this.catetobrandpercentloading=false;
				}
			}).catch((res) => {
				this.catetobrandpercentloading=false;
			});
		},


		/** 获取今年月份信息 **/
		getlocalmonths() {
			var resource = this.$resource(this.url);
			resource.query({act:'getlocalmonthalls',token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					this.months=result.allmonths;
					this.catesalepercentquery.month=result.localmonth;
					this.getcatesalespercent(); //获取品牌占所属类目比例
				}
			}).catch((res) => {
				
			});
		},


		/** 修改选中的月份 **/
		getmonths(name) {
			this.catesalepercentquery.month=name;
			this.getcatesalespercent();
		},

		/** 获取类目销售占比信息 **/
		getcatesalespercent() {
			this.catesalesloading=true;
			var resource = this.$resource(this.url);
			resource.save(this.catesalepercentquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.catesalesloading=false;
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					this.catesaleslists=result;
					this.catesalepercent.series[0].data=[];
					var _this=this;
					result.lists.forEach(function(e,index) {
						_this.catesalepercent.series[0].data.push({value:e.reals,name:e.name+"_"+e.salepercent+"%"});
					});
					this.catesalesloading=false;
				}
			}).catch((res) => {
				this.catesalesloading=false;
			});
		},

		/** 查看销售数据，图表展示 **/
	    checkcatesalesfromtable() {
			this.catesaletableDialog=true;
		},


		////////////////////////////////////////////////////
		//6图共用

		/** 修改渠道信息 **/
		changesaleschannel() {
			this.freshallstats();
		},

		/** 修改分类信息 **/
		changesalescate() {
			this.saleallquery.brandid='';
			this.saleallquery.productid='';
			//重新获取品牌信息
			this.brandquery.cateid=this.saleallquery.cateid;
			this.productlists=[];
			this.getBrand();
			this.freshallstats();
		},

		/** 修改品牌信息 **/
		changesalebrand() {
			this.saleallquery.productid='';
			this.productlists=[];
			this.freshallstats();
		},

		/** 修改商品信息 **/
		changeproduct() {
			this.freshallstats();
		},

		/** 刷新6图数据统计信息 **/
		freshallstats() {
			this.allrealstats(); //刷新实收金额趋势图
			if(this.saleallquery.productid > 0) this.allgoodsstats(); //刷新商品销量趋势图
			this.allprofitsstats(); //刷新利润趋势图
			this.allprofitpercentstats(); //刷新毛利趋势图
			this.allorderstats(); //刷新订单量趋势图
			this.allcustomerstats(); //刷新客单价趋势图
		},


		//刷新实收金额趋势图
		allrealstats() {
			this.saleallquery.act="getrealsaleorders";
			this.saleallquery.loading1=true;
			var resource = this.$resource(this.url);
			resource.save(this.saleallquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.saleallquery.loading1=false;
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					this.realsales.xAxis.data=result.month;
					var _this=this;
					_this.realsales.series[0].data=[];
					_this.realsales.series[1].data=[];
					result.lists.forEach(function(e,index) {
						_this.realsales.series[0].data.push({value:e.reals});
						_this.realsales.series[1].data.push({value:e.percent});
					});

					this.saleallquery.loading1=false;
				}
			}).catch((res) => {
				this.saleallquery.loading1=false;
			});
		},


		//刷新商品销量趋势图
		allgoodsstats() {
			this.saleallquery.act="getrealsalegoodnums";
			this.saleallquery.loading2=true;
			var resource = this.$resource(this.url);
			resource.save(this.saleallquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.saleallquery.loading2=false;
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					this.goodssales.xAxis.data=result.month;
					var _this=this;
					_this.goodssales.series[0].data=[];
					_this.goodssales.series[1].data=[];
					result.lists.forEach(function(e,index) {
						_this.goodssales.series[0].data.push({value:e.nums});
						_this.goodssales.series[1].data.push({value:e.percent});
					});
					this.saleallquery.loading2=false;
				}
			}).catch((res) => {
				this.saleallquery.loading2=false;
			});
		},


		//刷新利润趋势图
		allprofitsstats() {
			this.saleallquery.act="getrealsaleprofits";
			this.saleallquery.loading3=true;
			var resource = this.$resource(this.url);
			resource.save(this.saleallquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.saleallquery.loading3=false;
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					this.profitssales.xAxis.data=result.month;
					var _this=this;
					_this.profitssales.series[0].data=[];
					_this.profitssales.series[1].data=[];
					result.lists.forEach(function(e,index) {
						_this.profitssales.series[0].data.push({value:e.reals});
						_this.profitssales.series[1].data.push({value:e.percent});
					});

					this.saleallquery.loading3=false;
				}
			}).catch((res) => {
				this.saleallquery.loading3=false;
			});
		},

		//刷新毛利率趋势图
		allprofitpercentstats() {
			this.saleallquery.act="getrealsaleprofitspercent";
			this.saleallquery.loading4=true;
			var resource = this.$resource(this.url);
			resource.save(this.saleallquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.saleallquery.loading4=false;
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					this.profitsclearsales.xAxis.data=result.month;
					var _this=this;
					_this.profitsclearsales.series[0].data=[];
					_this.profitsclearsales.series[1].data=[];
					result.lists.forEach(function(e,index) {
						_this.profitsclearsales.series[0].data.push({value:e.reals});
						_this.profitsclearsales.series[1].data.push({value:e.percent});
					});

					this.saleallquery.loading4=false;
				}
			}).catch((res) => {
				this.saleallquery.loading4=false;
			});
		},

		//获取订单量趋势图
		allorderstats() {
			this.saleallquery.act="getrealsaleordersnums";
			this.saleallquery.loading5=true;
			var resource = this.$resource(this.url);
			resource.save(this.saleallquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.saleallquery.loading5=false;
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					this.orderssales.xAxis.data=result.month;
					var _this=this;
					_this.orderssales.series[0].data=[];
					_this.orderssales.series[1].data=[];
					result.lists.forEach(function(e,index) {
						_this.orderssales.series[0].data.push({value:e.reals});
						_this.orderssales.series[1].data.push({value:e.percent});
					});
					this.saleallquery.loading5=false;
				}
			}).catch((res) => {
				this.saleallquery.loading5=false;
			});
		},

		//获取客单价趋势图
		allcustomerstats() {
			this.saleallquery.act="getrealsalecustomers";
			this.saleallquery.loading6=true;
			var resource = this.$resource(this.url);
			resource.save(this.saleallquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.saleallquery.loading6=false;
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					this.averagesales.xAxis.data=result.month;
					var _this=this;
					_this.averagesales.series[0].data=[];
					_this.averagesales.series[1].data=[];
					result.lists.forEach(function(e,index) {
						_this.averagesales.series[0].data.push({value:e.reals});
						_this.averagesales.series[1].data.push({value:e.percent});
					});
					this.saleallquery.loading6=false;
				}
			}).catch((res) => {
				this.saleallquery.loading6=false;
			});
		},


		//6图共用
		////////////////////////////////////////////////////

     
    }
}
</script>

</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.shop-sale-table {padding:1% 1% 1% 1% !important;}
.shop-sale-table table {width:100%;border-radius:5px;border-collapse:collapse;border-spacing:0;border-left:1px solid rgb(221,221,221,.6);border-top:1px solid rgb(221,221,221,.6);margin-top:10px}
.shop-sale-table table td {border-right:1px solid rgb(221,221,221,.6);border-bottom:1px solid rgb(221,221,221,.6);font-size:13px;padding:10px 15px;color:#606266;}
.shop-sale-table table .shoptitle {background:rgb(221,221,221,.3);font-weight:550;font-size:13px}

.brand-cate-half {float:left;width:47.5%;padding:1% 1%;margin:0 0 10px 0;border-radius:15px;border:1px solid #ddd;background:#fff;overflow:hidden;transition:.3s all}
.brand-cate-half:nth-of-type(even) {float:right}
.brand-cate-half:hover {box-shadow:5px 5px 10px #666666}
.brand-cate-half-percent {float:left;font-size:13px}
.brand-cate-half-main {float:left;width:100%;margin-top:10px}
.brand-cate-half-title {float:left;width:100%;margin-top:10px;transition:.5s all}
.brand-cate-half-stat {float:left;width:100%;margin-top:10px}
.brand-cate-half-stat-title {float:left;font-size:13px;color:#E6A23C;margin-right:5%;margin-top:10px}
.brand-cate-half-stat-title i {margin-left:5px;font-style:normal;font-weight:bold;font-size:14px}

.brand-cate-all {float:left;width:98%;padding:1% 1%;margin:0 0 10px 0;border-radius:15px;border:1px solid #ddd;background:#fff;overflow:hidden;transition:.3s all}
.brand-cate-all:hover {box-shadow:5px 5px 10px #666666}
.brand-cate-move {position:fixed;left:0;bottom:0;padding:15px 5%;width:90%;z-index:10000;background:rgba(0,0,0,.8);}
</style>


// WEBPACK FOOTER //
// src/components/stat/statdatashow.vue